class ProductItem extends HTMLElement {
  constructor() {
    super()

    const swatches = this.querySelector('.product-item-swatches')
    const overlay = this.querySelector('.product-item-js__overlay')

    if (!swatches || !overlay) return

    let pending = null

    const show = src => {
      if (!src || pending === src) return
      pending = src

      const preload = new Image()
      preload.onload = () => {
        if (pending !== src) return
        overlay.src = src
        overlay.classList.add('active')
      }
      preload.src = src
    }

    const hide = () => {
      pending = null
      overlay.classList.remove('active')
    }

    swatches.addEventListener('mouseover', e => {
      const swatch = e.target.closest('.color-swatch')
      if (!swatch || !swatches.contains(swatch)) return
      show(swatch.dataset.variantImage)
    })

    swatches.addEventListener('mouseleave', hide)
  }
}

customElements.define('product-item', ProductItem)
